<template>
    <div>
        <div class="actions-block">
            <a :href="'/world-guide/pdf/country/' + country.id" class="action-link"><i class="fas fa-file-pdf mr-2"></i><span>Download PDF</span> </a>
        </div>
        <div class="box-common-ttl mb-3">
            <h3>
                <a :href="`/world-guide/country?id=${country.id}`">{{ country.country.name }}</a>
            </h3>
        </div>
        <div class="country-status-info-wrap">
            <div class="ttl" v-if="country.color_codes.length > 1">Statuses:</div>
            <div class="ttl" v-else>Status:</div>
            <div class="status" :style="setBackgroundColor(code.color)" v-for="code in country.color_codes">
<!--                <a :href="`/risk-rating?color_code=${code.name}`">{{ code.name }}</a>-->
                <a style="cursor:pointer;" @click="showCitiesWithinColorCodes(code)">{{ code.name }}</a>
            </div>
        </div>
        <transition name="fade">
            <div id="colors-with-cities" :class="['mb-3', {'animated fadeInDown': animated}]" v-show="displayCitiesWithinColorCodes">
                <div class="ttl">Cities/Regions: <strong >{{ citiesWithinColorCode }}</strong></div>
            </div>
        </transition>
        <gmap-map
            ref="worldGuidedMap"
            id="worldGuideMap"
            :style="`width: 100%; height: 24.5rem; margin-bottom: 1.5rem`"
            :center="map.center"
            :zoom="map.zoom"
            :options="{minZoom: 3, maxZoom: 20, streetViewControl: false}"
        >
            <gmap-marker
                style="height:25px; width:25px;"
                :icon="marker.icon"
                :position="{lat: marker.lat, lng: marker.lng}"
                :clickable="true"
                :draggable="false"
                @click="toggleInfoWindow"
            >
            </gmap-marker>
            <gmap-info-window
                :options="infoWindow.options"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @click="closeInfoWindow"
                @closeclick="closeInfoWindow"
                maxWidth="200px"
                ref="infoWindow"
            >
                <div v-html="infoWindow.content"></div>
            </gmap-info-window>
        </gmap-map>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Map from "../../../../Dashboard/resources/js/models/Map";
    import InfoWindow from "../../../../Dashboard/resources/js/models/InfoWindow";

    export default {
        props: {
            input_country: Object,
        },
        data() {
            return {
                map: {lat : 41.850033, lng : -98.6500523},
                marker: {},
                infoWindow: {},
                country: this.input_country,
                citiesWithinColorCode: null,
                displayCitiesWithinColorCodes: false,
                animated: false
            }
        },
        mounted() {
            this.marker.lat = this.input_country.lat ? this.input_country.lat : 44.33
            this.marker.lng = this.input_country.lng ? this.input_country.lng : -69.73

            if (this.country.color_codes.length) {
                this.marker.icon = {
                    url: `/img/gmap/marker-${this.country.color_codes[0].name}.png`,
                    scaledSize: {width: 30, height: 30},
                    labelOrigin: {x: 16, y: -10}
                };
            }

            this.map = new Map(8, {lat: this.marker.lat, lng: this.marker.lng});

            this.setInfoWindow();
        },
        computed: mapGetters(['GET_MARKERS_LIST']),
        methods: {
            closeInfoWindow() {
                this.infoWindow.open = false;
            },
            toggleInfoWindow() {
                this.map.center = {lat : this.marker.lat, lng : this.marker.lng}
                this.infoWindow.open = !this.infoWindow.open;
            },
            setInfoWindow() {
                const cities = [];

                if (this.country.cities) {
                    for (let i = 0; i < this.country.cities.length; i++) {
                        cities.push({
                            id: this.country.cities[i].id,
                            name: this.country.cities[i].name
                        });
                    }
                }

                let codes = ''

                for(let i = 0; i < this.country.color_codes.length; i++){
                    codes += `<div style="background-color: ${this.country.color_codes[i].color}" class="status">
                            <a href="/risk-rating?color_code=${this.country.color_codes[i].name}">${this.country.color_codes[i].name.toUpperCase()}</a>
                        </div>`
                }

                this.infoWindow = new InfoWindow(
                    { pixelOffset: { width: 170, height: 240 }},
                    `
                <div class="map-content">
                    <h3>
                        <a href="/world-guide/country?id=${this.country.id}">${this.country.country.name}</a>
                    </h3>
                    <div class="country-status-info-wrap">
                        <div class="ttl">Status: </div>
                        ${codes}
                    </div>
                    <p>${cities.length ? '<strong>City Guides:</strong>' : '' }</p>

                    ${cities.map((city, index) => `
                        <a href="/world-guide/city?id=${city.id}">${index === cities.length - 1 ? city.name : city.name + ', '}</a>
                    `).join('')}
                </div>
            `,
                    {lat: this.marker.lat, lng: this.marker.lng},
                    true
                );
            },
            setBackgroundColor(color) {
                return `background-color: ${color}`
            },
            showCitiesWithinColorCodes(code) {
                for (let i = 0; i < this.country.risk_ratings.length; i++) {
                    if (this.country.risk_ratings[i].color_code_id === code.id) {
                        this.citiesWithinColorCode = this.country.risk_ratings[i].region;

                        this.animated = true;
                        setTimeout(() => this.animated = false, 1000);

                        this.displayCitiesWithinColorCodes = true;
                    }
                }
            },
        },
    }
</script>

<style lang="less">
    @import "../../../../Dashboard/resources/less/dashboard-map";

    .gm-style-iw-d {
        overflow: initial !important;
        max-height: unset !important;
    }

    .gm-style .gm-style-iw-t::after {
        background: none !important;
    }

    .gm-style .gm-style-iw {
      width: 250px !important;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>
